export function sleep(ms) {
  return new Promise((resolve) => {
    setTimeout(() => resolve(), ms);
  });
}

export function promise(callback) {
  return (data) => new Promise((resolve, reject) => {
    callback && callback(data, resolve, reject);
  });
}

export async function sequence(iterable, action, callback) {
  for (const x of iterable) {
    await action(x)
  }

  callback&&callback();
}

export function repeatAsync(condition, callback, ms) {
  setTimeout(() => {
    if (condition()) {
      callback();
    } else {
      repeatAsync(condition, callback, ms)
    }
  }, ms);
};
